// Loom Loom PDP: connects the designer's ll-pdp.js to this Dawn theme.
// ll-pdp.js fires `cart:updated` after adding to cart; Dawn's cart drawer
// doesn't listen for it, so re-render and open the drawer here.
(() => {
  const root = window.Shopify?.routes?.root || '/';

  document.documentElement.addEventListener('cart:updated', async (e) => {
    const drawer = document.querySelector('cart-drawer');
    try {
      const sections = await (await fetch(root + '?sections=cart-drawer,cart-icon-bubble')).json();
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: null, sections });
      } else {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      }
    } catch (err) {
      console.error('ll-pdp: could not refresh cart drawer', err);
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'll-pdp', cartData: e.detail });
    }
  });

  // Height of the sticky header, so the sticky buy column sits below it.
  const setHeaderHeight = () => {
    const header = document.querySelector('.section-header');
    const cs = header && getComputedStyle(header);
    const h = cs && cs.position === 'sticky' ? header.offsetHeight + (parseFloat(cs.top) || 0) : 0;
    document.documentElement.style.setProperty('--ll-header-h', h + 'px');
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);
})();